'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, BarChart2, Store, Calculator } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const navItems = [
  { label: 'Token Dashboard', href: '/token-dashboard', icon: BarChart2 },
  { label: 'Food Directory', href: '/fast-food-crypto-directory', icon: Store },
  { label: 'Tip Calculator', href: '/tip-calculator', icon: Calculator },
];

export default function Topbar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-zinc-800 bg-zinc-950/90 backdrop-blur-md">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link href="/token-dashboard" className="flex items-center gap-2.5 shrink-0">
          <AppLogo size={32} />
          <span className="font-bold text-base text-white hidden sm:block tracking-tight">
            FastFood<span className="text-btcgold-500">Crypto</span>
          </span>
          <span className="font-mono text-xs px-1.5 py-0.5 rounded bg-btcgold-500/10 text-btcgold-400 border border-btcgold-500/20 hidden md:inline-flex">
            FFCT
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems?.map((item) => {
            const isActive = pathname === item?.href;
            const Icon = item?.icon;
            return (
              <Link
                key={`nav-${item?.href}`}
                href={item?.href}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                  isActive
                    ? 'bg-btcgold-500/10 text-btcgold-400 border border-btcgold-500/20' :'text-zinc-400 hover:text-white hover:bg-zinc-800'
                }`}
              >
                <Icon size={16} />
                {item?.label}
              </Link>
            );
          })}
        </nav>

        {/* Right side */}
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-green-500/10 border border-green-500/20">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
            <span className="text-xs font-medium text-green-400">Network Live</span>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors"
            aria-label="Toggle navigation"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden border-t border-zinc-800 bg-zinc-950 animate-slide-up">
          <nav className="max-w-screen-2xl mx-auto px-4 py-3 flex flex-col gap-1">
            {navItems?.map((item) => {
              const isActive = pathname === item?.href;
              const Icon = item?.icon;
              return (
                <Link
                  key={`mobile-nav-${item?.href}`}
                  href={item?.href}
                  onClick={() => setMobileOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-150 ${
                    isActive
                      ? 'bg-btcgold-500/10 text-btcgold-400 border border-btcgold-500/20' :'text-zinc-400 hover:text-white hover:bg-zinc-800'
                  }`}
                >
                  <Icon size={18} />
                  {item?.label}
                </Link>
              );
            })}
          </nav>
        </div>
      )}
    </header>
  );
}